import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import Screen from './screen';
import { gateway } from '../../../../utils/api';


function Grades({ turma }) {
  const [loading, setLoading] = useState(true);
  const [contentTable, setContentTable] = useState([]);
  const [gradeDetails, setGradeDetails] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingDetailsId, setLoadingDetailsId] = useState(null);

  console.log(turma)

  const fetchStudentGrades = useCallback(async () => {
    try {
      const classCode = turma.contentCode
      const email = localStorage.getItem("ra")
      const url = `person/person/getStudentGradeAndAbsences?email=${email}&classCode=${classCode}`;
      const courses = await gateway.get(url);
      setContentTable(courses)
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [turma]);

  const fetchGradeDetails = useCallback(async (idTurmaDisc) => {
    try {
      setLoadingDetailsId(idTurmaDisc);
      const email = localStorage.getItem("ra");
      const classCode = turma.contentCode;
      const url = `person/person/getStudentGradeDetails?email=${email}&classCode=${classCode}&IDTURMADISC=${idTurmaDisc}`;
      const details = await gateway.get(url);
      setGradeDetails(details);
      setIsModalOpen(true);
    } catch (error) {
      console.log('Erro ao buscar detalhes das notas:', error);
    } finally {
      setLoadingDetailsId(null);
    }
  }, [turma]);

  useEffect(() => {
    fetchStudentGrades();
  }, [fetchStudentGrades]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setGradeDetails(null);
  };

  return (
    <>
      <Screen 
        contentTable={contentTable} 
        isLoading={loading}
        onViewDetails={fetchGradeDetails}
        loadingDetailsId={loadingDetailsId}
        gradeDetails={gradeDetails}
        isModalOpen={isModalOpen}
        onCloseModal={handleCloseModal}
      />
    </>
  );
}

Grades.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  turma: PropTypes.object.isRequired,
};

export default Grades;
